<template>
  <div class="card-text grid-field-social-handle">
    <i
      v-if="display.iconClass"
      class="grid-field-social-handle__icon"
      :class="display.iconClass"
      role="img"
      :aria-label="iconLabel"
    ></i>
    <a
      v-if="display.href"
      :href="display.href"
      target="_blank"
      rel="noopener noreferrer"
      class="forced-pointer-events-auto grid-field-social-handle__text"
      @mousedown.stop
      >{{ display.text }}</a
    >
    <span v-else class="grid-field-social-handle__text">{{
      display.text
    }}</span>
  </div>
</template>

<script>
import {
  getPlatformName,
  getSocialHandleDisplay,
} from '@baserow/modules/database/utils/socialHandle'

export default {
  name: 'RowCardFieldSocialHandle',
  height: 16,
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    display() {
      return getSocialHandleDisplay(this.value, this.field.platform)
    },
    iconLabel() {
      return this.display.platform
        ? getPlatformName(this.display.platform)
        : this.$t('gridViewFieldSocialHandle.genericPlatform')
    },
  },
}
</script>
